import Vue from 'vue';
import { v4 } from 'uuid';
import Vuex, { Module, StoreOptions } from 'vuex';
import { IMxrConfig } from '@/interfaces/MxrConfig';
import { Tab } from '@/interfaces/Tab';
import { ProductShoppingListItem } from '@/interfaces/ProductShoppingListItem';
import { IRootState } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

Vue.use(Vuex);

export const MXRStore: Module<IRootState, IRootState> = {
    state: {
        activeCardIndex: -1,
        previousCardIndex: -1,
        config: { id: '' } as IMxrConfig,
        selectedTab: Tab.Tab1,
        selectedTabIndex: 0,
        sessionId: v4(),
        visiblePromotionIds: [],
        visiblePromotionUniqueIds: [],
        loadingPromotions: true,
        previousPromotion: null,
        selectedOfferIds: [],
        mxrRetailerLocations: [],
        currentMxrRetailerIndex: 0,
        productShoppingListSections: [],
        selectedSwap: new ProductShoppingListItem('', '', '', '', '', false, false, '', '', ''),
        selectedSwapSection: 0,
        swapOptions: [],
        swapSlot: false,
        retailerLocationsModalOpen: false,
        isBeta: false,
        mxrJSONData: '',
        takeover: null,
        isDefault: false,
        krogerAuthConfig: {
            baseUri: '',
            clientId: '',
            responseType: '',
            scope: '',
            redirectUri: '',
        },
        goToCartOpen: false,
        mercuryLocationResult: null,
        fulfillmentStore: null,
        checkoutTotal: 0,
        offersCountInCart: 0
    } as IRootState,
    actions,
    mutations,
    getters,
};
